module.exports = __webpack_public_path__ + "static/media/map.98df8184.png";